import initI18n from './i18n';

/** Registers the program-ui i18n namespace. */
export default function init(): void {
  initI18n();
}
